export const RESTRICTED_ACCESS = 'Restricted access';
export const OPEN_ACCESS = 'Open access';

export const OPERATIONAL = 'Operational';
export const DECOMMISSIONED = 'Decommissioned';

export const ES_RESOURCE_TYPE = 'Experiment Session';
export const DC_RESOURCE_TYPE = 'Datacollection';
export const INSTR_RESOURCE_TYPE = 'Instrument';

// ESRF DOI suffixes start with ESRF-ES-, ESRF-DC- or ESRF-INSTR-; instrument
// DOIs are never indexed in ICAT+, so this is detected from the DOI string
// itself, before any fetch, to skip straight to the DataCite API.
export const INSTRUMENT_DOI_SUFFIX_PREFIX = 'ESRF-INSTR-';

// Compared case-insensitively against values from DataCite, whose casing we
// don't control, so these are stored upper case to skip normalizing them on
// every comparison — only the incoming DataCite value needs .toUpperCase().
export const CATEGORY_SUBJECT_SCHEME = 'PROPOSAL TYPE DESCRIPTION';
export const INSTRUMENT_SUBJECT_SCHEME = 'INSTRUMENT';
export const PROPOSAL_SUBJECT_SCHEME = 'PROPOSAL';

// Ontologies describing the physics technique/measured variable (e.g. SAXS)
export const MEASURED_VARIABLE_SUBJECT_SCHEMES = new Set(['ESRFET', 'PANET']);

export const KNOWN_SUBJECT_SCHEMES = new Set([
  INSTRUMENT_SUBJECT_SCHEME,
  PROPOSAL_SUBJECT_SCHEME,
  CATEGORY_SUBJECT_SCHEME,
  ...MEASURED_VARIABLE_SUBJECT_SCHEMES,
]);

export const COLLECTED_DATE_TYPE = 'COLLECTED';

export const COVERAGE_DATE_TYPE = 'COVERAGE';

export const RELEASED_DATE_TYPE = 'AVAILABLE';

export const ABSTRACT_DESCRIPTION_TYPE = 'ABSTRACT';

export const ORCID_IDENTIFIER_SCHEME = 'ORCID';

export const ROR_IDENTIFIER_SCHEME = 'ROR';

export const OWNER_CONTRIBUTOR_TYPE = 'HostingInstitution';

export const ALIAS_IDENTIFIER_TYPE = 'ALIAS';

export const COLLECTION_DATE_FORMAT = 'yyyy-MM-dd';

export const RELATED_IDENTIFIER_TYPE_RELATED_DOI = 'IsSupplementedBy';

export const RELATED_IDENTIFIER_TYPE_IS_CITED_BY = 'IsCitedBy';

export const RELATED_IDENTIFIER_TYPE_REFERENCES = 'References';

export const RELATED_IDENTIFIER_TYPE_DESCRIBED_BY = 'IsDescribedBy';

export const RELATED_IDENTIFIER_TYPE_NEW_VERSION_OF = 'IsNewVersionOf';

export const RELATED_IDENTIFIER_TYPE_PREVIOUS_VERSION_OF =
  'IsPreviousVersionOf';
